(() => {
  'use strict';
  const gallery = document.querySelector('.gnagfri-gallery');
  if (!gallery || typeof EmblaCarousel !== 'function') return;
  const viewport = gallery.querySelector('.gnagfri-gallery-track');
  const thumbs = [...gallery.querySelectorAll('[data-gnagfri-slide]')];
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const carousel = EmblaCarousel(viewport, {
    align: 'start',
    loop: false,
    dragFree: false,
    skipSnaps: false,
    slidesToScroll: 1,
    duration: 25,
    breakpoints: { '(prefers-reduced-motion: reduce)': { duration: 0 } }
  });
  const select = () => {
    const selected = carousel.selectedScrollSnap();
    thumbs.forEach((thumb, index) => thumb.setAttribute('aria-current', String(index === selected)));
  };
  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => carousel.scrollTo(index, reducedMotion.matches)));
  viewport.addEventListener('keydown', event => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    event.preventDefault();
    carousel.scrollTo(carousel.selectedScrollSnap() + (event.key === 'ArrowRight' ? 1 : -1), reducedMotion.matches);
  });
  // Trackpad momentum is one gesture; Embla owns the actual slide animation.
  let wheelTimer, wheelTotal = 0, wheelMoved = false, dragging = false;
  viewport.addEventListener('wheel', event => {
    if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
    event.preventDefault();
    clearTimeout(wheelTimer);
    wheelTimer = setTimeout(() => { wheelTotal = 0; wheelMoved = false; }, 220);
    if (wheelMoved || dragging) return;
    wheelTotal += event.deltaX * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? viewport.clientWidth : 1);
    if (Math.abs(wheelTotal) < 20) return;
    wheelMoved = true;
    carousel.scrollTo(carousel.selectedScrollSnap() + Math.sign(wheelTotal), reducedMotion.matches);
  }, { passive: false });
  carousel.on('pointerDown', () => { dragging = true; viewport.classList.add('is-dragging'); });
  carousel.on('pointerUp', () => {
    dragging = false;
    viewport.classList.remove('is-dragging');
    if (reducedMotion.matches) queueMicrotask(() => carousel.scrollTo(carousel.selectedScrollSnap(), true));
  });
  carousel.on('select', select).on('reInit', select);
  select();
})();
